// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1793780583171
      var cssReload = require("D:/a/1/as3-portals/AS3.Web/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"./","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  